/**
 * Hospital API Client Functions
 */
import { apiClient } from '../api-client';

export interface Hospital {
  id: number;
  name: string;
  code?: string;
  city?: string;
  state?: string;
  is_active: boolean;
}

export interface HospitalDetail extends Hospital {
  address?: string;
  pincode?: string;
  phone?: string;
  email?: string;
  created_at: string;
}

export interface HospitalCreateData {
  name: string;
  code?: string;
  address?: string;
  city?: string;
  state?: string;
  pincode?: string;
  phone?: string;
  email?: string;
  is_active?: boolean;
}

export interface HospitalUpdateData {
  name?: string;
  code?: string;
  address?: string;
  city?: string;
  state?: string;
  pincode?: string;
  phone?: string;
  email?: string;
  is_active?: boolean;
}

/**
 * Hospital API functions
 */
export const hospitalsApi = {
  /**
   * Get list of all hospitals (public endpoint for signup)
   */
  async getAll(params?: { is_active?: boolean; search?: string }): Promise<{ hospitals: Hospital[] }> {
    const response = await apiClient.get('/hospitals', params);
    return response;
  },

  /**
   * Get hospital by ID (public endpoint)
   */
  async getById(hospitalId: number): Promise<HospitalDetail> {
    const response = await apiClient.get(`/hospitals/${hospitalId}`);
    return response;
  },

  /**
   * Create new hospital (requires COORDINATOR role)
   */
  async create(data: HospitalCreateData): Promise<{ status: string; message: string; hospital: Hospital }> {
    const response = await apiClient.post('/hospitals', data);
    return response;
  },

  /**
   * Update hospital (requires COORDINATOR role)
   */
  async update(hospitalId: number, data: HospitalUpdateData): Promise<{ status: string; message: string; hospital: Hospital }> {
    const response = await apiClient.put(`/hospitals/${hospitalId}`, data);
    return response;
  },

  /**
   * Delete hospital (requires COORDINATOR role)
   */
  async delete(hospitalId: number): Promise<{ status: string; message: string }> {
    const response = await apiClient.delete(`/hospitals/${hospitalId}`);
    return response;
  },
};